<div class="view-page-container">
  <div class="view-toolbar">
    <button type="button" pButton (click)="backClicked.emit()"><msi-icon name="ic_back" /></button>
    <div class="view-toolbar-right">
      <button type="button" pButton (click)="deleteClicked.emit()" [disabled]="!CanDelete">
        <msi-icon name="ic_trash" />{{ 'Buttons.delete' | transloco }}
      </button>
      <button type="button" pButton (click)="printClicked.emit()" [disabled]="!CanCreateReports">
        <msi-icon name="ic_printer" />{{ 'Buttons.exportToPdf' | transloco }}
      </button>
      <button type="button" pButton (click)="editButtonClicked()" [disabled]="!CanEdit">
        <msi-icon name="ic_edit" />{{ 'Buttons.edit' | transloco }}
      </button>
    </div>
  </div>
  <ng-container *transloco="let t; prefix:'PremiseHazard'">
    <div class="item-view-container">
      @if (IsLoading) {
      <div class="justify-content-center">
        <p-progress-spinner size="xlarge" ariaLabel="loading" animationDuration="2s" />
      </div>
      } @else if (PremiseHazard) {
      <ng-container *ngTemplateOutlet="hazardView"></ng-container>
      } @else {
      <ng-container *ngTemplateOutlet="emptyView"></ng-container>
      }
    </div>

    <ng-template #emptyView>
      {{ t('View.text.noRecords') }}
    </ng-template>

    <ng-template #hazardView>
      <ng-container *ngTemplateOutlet="headerInformation"></ng-container>
      <ng-container *ngTemplateOutlet="typeInformation"></ng-container>
      <ng-container *ngTemplateOutlet="addressInformation"></ng-container>
      <ng-container *ngTemplateOutlet="attachmentsInformation"></ng-container>
      <ng-container *ngTemplateOutlet="attachmentControls"></ng-container>
      <ng-container *ngTemplateOutlet="contactsInformation"></ng-container>
      <ng-container *ngTemplateOutlet="commentsInformation"></ng-container>
      <ng-container *ngTemplateOutlet="isTemporaryHazard"></ng-container>
      <ng-container *ngTemplateOutlet="authorizationInformation"></ng-container>
      <ng-container *ngTemplateOutlet="ownerInformation"></ng-container>
      <ng-container *ngTemplateOutlet="systemInformation"></ng-container>
    </ng-template>

    <ng-template #headerInformation>
      <div class="hazard-information-header">
        <label class="msi-label">{{ t('label.name') }}</label>
        <div class="msi-margin-left-s">{{PremiseHazard.recordTitle}}</div>
      </div>
      @if (isShared) {
      <div class="msi-margin-s">
        <msi-callout [type]=infoCalloutType [closable]=false>
          <div calloutContent>
            {{ t('View.text.sharedHazard') }}
          </div>
        </msi-callout>
      </div>
      }
      <div>
        <div class="msi-margin-s">
          @if (PremiseHazard.isReviewRequired) {
          <msi-callout [type]=warningCalloutType>
            <div calloutContent>
              {{ t('label.reviewRequired') }}
            </div>
          </msi-callout>
          }
        </div>
      </div>
      <div>
        <label class="msi-label">{{ t('label.priority') }} </label>
        <div class="msi-margin-left-s">{{PremiseHazard.priority}}</div>
      </div>
    </ng-template>

    <ng-template #ownerInformation>
      <div>
        <label class="msi-label">{{ t('label.ownerInformation') }}</label>
        <div class="view-wrapper">
          <div class="information-column">
            <label class="msi-label">{{ t('label.name') }} </label>
            <div class="msi-margin-left-s">{{PremiseHazard.ownerName | emptyText}}</div>
          </div>
          <div class="information-column-margin">
            <label class="msi-label">{{ t('label.address') }} </label>
            <div class="msi-margin-left-s">
              {{PremiseHazard.ownerAddress | emptyText}}
            </div>
          </div>
          <div class="information-column-margin">
            <label class="msi-label">{{ t('label.phoneNumber') }} </label>
            <div class="msi-margin-left-s">
              {{PremiseHazard.ownerPhone | emptyText}}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #commentsInformation>
      <div class="comments-wrapper">
        <label class="msi-label">{{ t('label.comments') }}</label>
        <div class="comments-content">
          <p>
            {{PremiseHazard.comments | emptyText:NoCommentsText}}
          </p>
        </div>
      </div>
    </ng-template>

    <ng-template #authorizationInformation>
      @if (!PremiseHazard.isReviewRequired && PremiseHazard.authorizingPersonnel) {
      <label class="msi-label">{{ t('label.authorizedBy') }} </label>
      {{ PremiseHazard.authorizingPersonnel | emptyText }}
      }
    </ng-template>

    <ng-template #systemInformation>
      <div class="hazard-information-header">
        <label class="msi-label">{{ t('label.systemInfo') }}</label>
        <div class="information-column-margin;">
          <div class="information-column">
            <label class="msi-label">{{ t('label.createdOn') }}</label>
            <div class="msi-margin-left-s">
              {{PremiseHazard.insertedTimestamp | date:dateFormat}}
            </div>
          </div>
        </div>
        <div class="hazard-wrapping-information-content">
          <div class="hazard-single-line-information">
            <div class="information-column">
              <label class="msi-label">{{ t('label.lastUpdatedBy') }}</label>
              <div class="msi-margin-left-s">
                {{PremiseHazard.lastUpdateUserId}}
              </div>
            </div>
            @if (PremiseHazard.updatedTimestamp) {
            <div class="information-column-margin">
              <label class="msi-label">{{ t('label.lastUpdated') }}</label>
              <div class="msi-margin-left-s">
                {{PremiseHazard.updatedTimestamp | date:dateFormat}}
              </div>
            </div>
            }
            <div class="information-column-margin;">
              <label class="msi-label">{{ t('label.agency') }}</label>
              <div class="msi-margin-left-s">
                {{PremiseHazard.lastUpdateUserAgencyId | emptyText}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #contactsInformation>
      <div class="msi-margin-s">
        @if (PremiseHazard.contacts && PremiseHazard.contacts.length !== 0) {
        <ng-container *ngTemplateOutlet="hasContacts"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="noContacts"></ng-container>
        }
      </div>
    </ng-template>

    <ng-template #attachmentsInformation>
      <div class="msi-margin-s">
        @if (PremiseHazard.attachments && PremiseHazard.attachments.length !== 0) {
        <ng-container *ngTemplateOutlet="hasAttachments"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="noAttachments"></ng-container>
        }
      </div>
    </ng-template>

    <ng-template #attachmentControls>
      <div class="msi-margin-top-m">
        <button pButton (click)="addAttachmentClicked()" [disabled]="isShared">
          <msi-icon name="ic_upload" />{{ t('label.uploadAttachment') }}
        </button>
      </div>
    </ng-template>
    <ng-template #typeInformation>
      <div class="msi-padding-top-s">
        @if (PremiseHazard.type) {
        <ng-container *ngTemplateOutlet="hasType"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="noType"></ng-container>
        }
      </div>
    </ng-template>
    <ng-template #addressInformation>
      <div class="msi-padding-top-s">
        @if (PremiseHazard.address) {
        <ng-container *ngTemplateOutlet="hasAddress"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="noAddress"></ng-container>
        }
      </div>
    </ng-template>

    <ng-template #hasAddress>
      <label class="msi-label">{{ t('label.addressSummary') }}</label>
      <div class="information-column-margin">
        <div class="information-row">
          @if (PremiseHazard.address?.commonPlace) {
          <div>
            <label class="msi-label">{{ t('label.locationName') }}</label>
            <div class="msi-padding-left-s">
              {{PremiseHazard.address?.commonPlace | emptyText}}
            </div>
          </div>
          }
          <div [class.msi-padding-left-s]="PremiseHazard.address?.commonPlace">
            <label class="msi-label">{{ t('label.address') }}</label>
            <div class="msi-padding-left-s">
              {{PremiseHazard.address?.houseAddress | emptyText}}
            </div>
          </div>
        </div>
        <div class="information-row">
          <div>
            <label class="msi-label">{{ t('label.city') }}</label>
            <div class="msi-padding-left-s">
              {{PremiseHazard.address?.city | emptyText}}
            </div>
          </div>
          <div class="msi-padding-left-s">
            <label class="msi-label">{{ t('label.state') }}</label>
            <div class="msi-padding-left-s">
              {{PremiseHazard.address?.state | emptyText}}
            </div>
          </div>
          <div class="msi-padding-left-s">
            <label class="msi-label">{{ t('label.zipCode') }}</label>
            <div class="msi-padding-left-s">
              {{PremiseHazard.address?.postalCode | emptyText}}
            </div>
          </div>
        </div>
        <div>
          <label class="msi-label">
            {{ t('label.coordinates') }}
          </label>
          <div class="msi-padding-left-s">
            {{PremiseHazard.address?.longitude}}, {{PremiseHazard.address?.latitude}}
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #noAddress>
      <msi-callout [type]=errorCalloutType>
        <div calloutContent>
          {{ t('View.text.noAddressError') }}
        </div>
      </msi-callout>
    </ng-template>

    <ng-template #noContacts>
      <msi-callout [type]=infoCalloutType>
        <div calloutContent>
          {{ t('View.text.noContacts') }}
        </div>
      </msi-callout>
    </ng-template>

    <ng-template #hasContacts>
      <label class="msi-label">{{ t('label.contacts') }}</label>
      <p-table [value]="Contacts">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col">{{ t('label.contactName') }}</th>
            <th scope="col">{{ t('label.created') }}</th>
            <th scope="col">{{ t('label.updated') }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contact>
          <tr>
            <td>{{contact.name | emptyText}}</td>
            <td>{{contact.insertedTimestamp | date:dateFormat}}</td>
            <td>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              @if (contact.devices && contact.devices.length !== 0) {
              <p-table [value]="contact.devices">
                <ng-template pTemplate="header">
                  <tr>
                    <th scope="col">{{ t('label.deviceType') }}</th>
                    <th scope="col">{{ t('label.address') }}</th>
                    <th scope="col">{{ t('label.created') }}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-device>
                  <tr>
                    <td>{{device.deviceType}}</td>
                    <td>{{device.address | emptyText}}</td>
                    <td>{{device.insertedTimestamp | date:dateFormat}}</td>
                  </tr>
                </ng-template>
              </p-table>
              } @else {
              {{ t('View.text.noDevices') }}
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-template>

    <ng-template #hasType>
      <label class="msi-label">{{ t('label.typeSummary') }}</label>
      <div class="information-row;">
        <div class="information-column-margin">
          <label class="msi-label">{{ t('label.name') }}</label>
          <div class="msi-padding-left-s"> {{PremiseHazard.type?.code | emptyText}}</div>
        </div>
        <div class="information-column-margin">
          <label class="msi-label">{{ t('label.description') }}</label>
          <div class="msi-padding-left-s"> {{PremiseHazard.type?.description | emptyText}}</div>
        </div>
        <div class="information-column-margin">
          <label class="msi-label">{{ t('label.createdOn') }}</label>
          <div class="msi-padding-left-s"> {{PremiseHazard.type?.insertedTimestamp | date:dateFormat}}</div>
        </div>
      </div>
    </ng-template>

    <ng-template #noType>
      @if (!PremiseHazard.type) {
      <msi-callout [type]=warningCalloutType>
        <div calloutContent>
          {{ t('View.text.noType') }}
        </div>
      </msi-callout>
      }
    </ng-template>

    <ng-template #hasAttachments>
      <label class="msi-label">{{ t('label.attachments') }}</label>
      <p-table [value]="Attachments">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col">{{ t('label.attachmentName') }}</th>
            <th scope="col">{{ t('label.filename') }}</th>
            <th scope="col">{{ t('label.size') }}</th>
            <th scope="col">{{ t('label.created') }}</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-attachment>
          <tr>
            <td>{{ attachment.attachmentName | emptyText | attachmentNameLimit }}</td>
            <td>
              <div style="display:flex; align-items:center; gap:4px;">
                <span>{{ attachment.fileName | emptyText | attachmentNameLimit }}</span>
                @if (attachment.canConvert) {
                <p-button [text]="true" (click)="convertAttachmentClicked(attachment)" [disabled]="!CanUpload"
                          [msiTooltip]="t('label.convert')" position="top">
                  <ng-template pTemplate="icon"><msi-icon name="ic_refresh" /></ng-template>
                </p-button>
                }
              </div>
            </td>
            <td>{{attachment.fileSize | fileSize}}</td>
            <td>{{attachment.whenCreated | date:dateFormat }}</td>
            <td>
              <ng-container [ngTemplateOutlet]="attachmentButtons" [ngTemplateOutletContext]="{ attachment: attachment}">
              </ng-container>
            </td>
          </tr>
          <tr class="msi-margin-left-s">
            <td colspan="6">{{ attachment.comments | emptyText:NoCommentsText }}</td>
          </tr>
        </ng-template>
      </p-table>
    </ng-template>

    <ng-template #attachmentButtons let-attachment="attachment">
      @if (attachment.isComplete) {
      <div class="flex-container-row">
        <div class="flex-container-column">
          <p-button (click)="onViewAttachmentClicked(attachment)" [disabled]="!CanUpload">
            <ng-template pTemplate="icon"><msi-icon name="ic_download" /></ng-template>
          </p-button>
        </div>
        <div class="flex-container-column">
          <p-button (click)="deleteAttachmentClicked(attachment)"
                  [disabled]="isShared || !CanUpload">
            <ng-template pTemplate="icon"><msi-icon name="ic_remove"/></ng-template>
          </p-button>
        </div>
      </div>
      }
    </ng-template>

    <ng-template #noAttachments>
      <msi-callout [type]=infoCalloutType>
        <div calloutContent>
          {{ t('View.text.noAttachments') }}
        </div>
      </msi-callout>
    </ng-template>

    <ng-template #isTemporaryHazard>
      @if (PremiseHazard.isTemporary) {
      {{ t('label.temporaryHazardInfo') }}
      <div class="msi-padding-m">
        <div>
          <div>
            <label class="msi-label">{{ t('label.purgeDate') }}</label> {{
  PremiseHazard.purgeDate |
                          date:dateFormat
            }}
          </div>
        </div>
        <div>
          <div>
            <label class="msi-label">{{ t('label.purgeType') }}</label> {{
  PremiseHazard.purgeType |
                          emptyText:NoPurgeTypeText
            }}
          </div>
        </div>
      </div>
      }
    </ng-template>
  </ng-container>
</div>